function lastNinetyDays() {
  const now = new Date();
  now.setUTCHours(0, 0, 0, 0);

  const dates = [];
  for (let i = 89; i >= 0; i--) {
    const date = new Date(now);
    date.setUTCDate(date.getUTCDate() - i);
    dates.push(date.toISOString());
  }
  return dates;
}

export const routeTableSampleRoutesStats = {
  clientError: {
    count: [
      6265, 988, 918, 8291, 8575, 9423, 9391, 7844, 869, 571, 7446, 8634, 8362,
      7436, 7444, 513, 314, 3699, 8743, 8360, 9345, 7959, 1319, 18321, 8177,
      9028, 8626, 9677, 6689, 838, 762, 8469, 9185, 10967, 9147, 9358, 871, 359,
      9540, 8562, 8118, 10856, 8434, 703, 357, 9222, 8984, 8491, 8421, 9358,
      366, 655, 9646, 10151, 8885, 4017, 3851, 1148, 1853, 9444, 8961, 10347,
      8911, 9485, 1642, 780, 9555, 10830, 11084, 8293, 9905, 1587, 912, 11868,
      10530, 9828, 8975, 9652, 673, 304, 7769, 10948, 9291, 8351, 8988, 1025,
      474, 7610, 9013, 11831, 3072,
    ],
    mean: [
      42.58, 43.322, 36.195, 40.466, 40.562, 45.487, 52.364, 51.066, 65.304,
      31.819, 51.065, 51.146, 52.721, 52.838, 52.457, 57.188, 68.483, 46.206,
      50.688, 55.243, 50.461, 57.47, 32.686, 415.28, 49.966, 46.243, 44.622,
      49.346, 47.713, 58.728, 88.232, 52.943, 54.19, 49.128, 43.738, 48.394,
      42.286, 41.98, 50.464, 52.278, 45.899, 45.791, 47.667, 33.3, 33.36,
      49.043, 50.05, 49.119, 53.09, 48.86, 31.512, 36.318, 48.94, 387.39, 49.34,
      39.616, 48.857, 30.207, 45.66, 47.634, 43.448, 44.899, 44.857, 48.379,
      34.167, 28.439, 46.107, 43.542, 46.632, 43.228, 46.478, 45.188, 50.46,
      42.703, 50.062, 45.214, 48.883, 45.513, 67.418, 58.278, 47.936, 73.247,
      72.494, 53.722, 44.306, 59.549, 47.85, 48.732, 51.428, 637.628, 86.487,
    ],
    satisfied: [
      6263, 987, 918, 8289, 8574, 9411, 9387, 7841, 864, 568, 7439, 8627, 8361,
      7433, 7442, 512, 310, 3697, 8733, 8358, 9341, 7959, 1318, 15635, 8171,
      9025, 8623, 9674, 6688, 838, 751, 8464, 9179, 10964, 9146, 9348, 871, 358,
      9533, 8559, 8114, 10852, 8433, 703, 355, 9218, 8981, 8484, 8411, 9357,
      366, 649, 9636, 9173, 8858, 4015, 3843, 1148, 1851, 9441, 8959, 10337,
      8908, 9482, 1642, 780, 9544, 10830, 11079, 8289, 9904, 1583, 908, 11864,
      10515, 9823, 8966, 9651, 666, 302, 7765, 10827, 9230, 8323, 8987, 1023,
      474, 7610, 8995, 8865, 3035,
    ],
    tolerating: [
      0, 0, 0, 0, 1, 9, 4, 1, 2, 3, 1, 4, 1, 3, 0, 0, 3, 1, 9, 0, 3, 0, 1, 522,
      4, 3, 1, 2, 1, 0, 3, 2, 5, 1, 1, 10, 0, 1, 2, 3, 2, 1, 0, 0, 2, 4, 2, 5,
      1, 1, 0, 6, 8, 8, 21, 1, 3, 0, 1, 2, 2, 7, 3, 3, 0, 0, 7, 0, 3, 0, 1, 1,
      2, 3, 6, 4, 5, 1, 1, 0, 4, 15, 0, 10, 1, 1, 0, 0, 2, 982, 6,
    ],
    frustrated: [
      2, 1, 0, 2, 0, 3, 0, 2, 3, 0, 6, 3, 0, 0, 2, 1, 1, 1, 1, 2, 1, 0, 0, 2164,
      2, 0, 2, 1, 0, 0, 8, 3, 1, 2, 0, 0, 0, 0, 5, 0, 2, 3, 1, 0, 0, 0, 1, 2, 9,
      0, 0, 0, 2, 970, 6, 1, 5, 0, 1, 1, 0, 3, 0, 0, 0, 0, 4, 0, 2, 4, 0, 3, 2,
      1, 9, 1, 4, 0, 6, 2, 0, 106, 61, 18, 0, 1, 0, 0, 16, 1984, 31,
    ],
  },
  noticeCount: [
    20, 51, 40, 5, 0, 3, 0, 0, 0, 0, 3, 0, 1, 0, 0, 1, 0, 0, 0, 1, 3, 0, 0, 129,
    5, 0, 0, 0, 2, 0, 2, 1, 0, 0, 2, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 1, 0,
    0, 2, 0, 0, 1, 120, 0, 4, 0, 0, 0, 2, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0,
    1, 2, 1, 1, 1, 2, 2, 1, 0, 2, 1, 0, 0, 4, 0, 18, 2,
  ],
  redirection: {
    count: [
      560, 646, 496, 1270, 1301, 7170, 1648, 1136, 474, 280, 1053, 1356, 1571,
      1057, 979, 259, 1212, 655, 1366, 1883, 994, 1226, 420, 711, 1795, 1362,
      2145, 1189, 964, 656, 1162, 1128, 1162, 1298, 1115, 1181, 284, 340, 1081,
      1802, 2153, 989, 1437, 403, 609, 1513, 1195, 2336, 1515, 1438, 363, 269,
      1427, 2096, 2859, 1339, 1850, 473, 387, 1558, 1684, 1903, 2031, 1484, 449,
      317, 1915, 1306, 1586, 1142, 1271, 250, 562, 1133, 1218, 1766, 5866, 1013,
      298, 404, 1359, 957, 1636, 1699, 1067, 394, 744, 821, 1044, 1455, 1307,
    ],
    mean: [
      34.415, 16.805, 22.278, 40.781, 38.724, 10.408, 34.174, 36.862, 17.887,
      16.097, 43.882, 30.524, 20.993, 38.57, 36.781, 23.254, 11.611, 42.846,
      54.964, 125.609, 32.867, 80.927, 25.171, 16.543, 64.668, 79.205, 47.215,
      56.257, 48.33, 9.862, 15.919, 82.101, 38.849, 28.574, 36.269, 52.152,
      21.227, 19.559, 57.863, 41.872, 26.977, 39.844, 36.435, 14.521, 25.26,
      474.235, 384.618, 91.232, 27.934, 30.284, 29.722, 50.533, 33.947, 27.335,
      26.198, 28.546, 39.748, 17.452, 16.799, 35.865, 30.219, 31.376, 33.922,
      32.371, 18.122, 18.28, 20.065, 39.532, 25.015, 21.623, 34.965, 29.075,
      20.354, 40.535, 42.701, 105.96, 11.071, 41.831, 19.32, 27.148, 34.818,
      41.068, 30.575, 39.179, 38.193, 16.843, 41.11, 33.566, 36.615, 28.955,
      31.833,
    ],
    satisfied: [
      559, 644, 493, 1256, 1291, 7166, 1635, 1127, 473, 280, 1043, 1346, 1566,
      1047, 972, 257, 1211, 651, 1344, 1867, 989, 1197, 419, 710, 1769, 1348,
      2137, 1176, 958, 656, 1159, 1113, 1150, 1294, 1105, 1168, 283, 338, 1058,
      1777, 2139, 982, 1426, 403, 605, 1492, 1180, 2320, 1509, 1427, 361, 264,
      1422, 2087, 2840, 1331, 1833, 472, 387, 1544, 1675, 1888, 2010, 1468, 447,
      316, 1912, 1292, 1575, 1139, 1252, 249, 560, 1114, 1209, 1749, 5847, 1005,
      297, 402, 1350, 947, 1623, 1685, 1060, 394, 711, 814, 1039, 1447, 1298,
    ],
    tolerating: [
      1, 2, 3, 10, 9, 4, 10, 6, 1, 0, 8, 9, 4, 7, 4, 2, 1, 1, 18, 12, 5, 25, 1,
      0, 18, 9, 7, 10, 3, 0, 3, 10, 9, 4, 7, 13, 1, 2, 21, 24, 12, 3, 10, 0, 4,
      7, 7, 8, 5, 9, 1, 2, 3, 8, 15, 7, 12, 1, 0, 12, 7, 12, 19, 15, 2, 1, 3,
      14, 9, 3, 19, 0, 1, 17, 8, 11, 15, 7, 1, 1, 8, 9, 10, 11, 5, 0, 33, 6, 4,
      5, 9,
    ],
    frustrated: [
      0, 0, 0, 4, 1, 0, 3, 3, 0, 0, 2, 1, 1, 3, 3, 0, 0, 3, 4, 4, 0, 4, 0, 1, 8,
      5, 1, 3, 3, 0, 0, 5, 3, 0, 3, 0, 0, 0, 2, 1, 2, 4, 1, 0, 0, 14, 8, 8, 1,
      2, 1, 3, 2, 1, 4, 1, 5, 0, 0, 2, 2, 3, 2, 1, 0, 0, 0, 0, 2, 0, 0, 1, 1, 2,
      1, 6, 4, 1, 0, 1, 1, 1, 3, 3, 2, 0, 0, 1, 1, 3, 0,
    ],
  },
  serverError: {
    count: [
      0, 0, 6, 6, 0, 2, 0, 0, 0, 0, 0, 0, 1, 4, 1, 1, 0, 0, 1, 0, 765, 0, 0,
      2002, 0, 0, 0, 0, 2, 0, 1, 9, 0, 0, 64, 1, 0, 0, 2, 0, 2, 4, 9, 15, 0, 4,
      1, 1, 0, 1, 0, 0, 0, 3, 3474, 3, 3, 0, 6, 0, 1, 10, 0, 1, 3, 9, 23, 7, 0,
      6, 0, 0, 15, 15, 4, 4, 3, 3, 1, 2, 1, 6, 1, 1, 0, 1, 0, 1, 0, 196, 0,
    ],
    mean: [
      0, 0, 50.046, 91.141, 0, 18.338, 0, 0, 0, 0, 0, 0, 90.174, 82.722,
      302.527, 10.563, 0, 0, 119.221, 0, 8.779, 0, 0, 6.423, 0, 0, 0, 0,
      276.546, 0, 566.062, 372.753, 0, 0, 32.402, 420.359, 0, 0, 22.947, 0,
      1131.395, 74.525, 415.933, 521.495, 0, 47.107, 60163.084, 146.149, 0,
      42.24, 0, 0, 0, 259.353, 30.737, 1252.998, 292.935, 0, 517.193, 0, 46.156,
      7237.233, 0, 244.315, 6.144, 140.62, 225.959, 658.785, 0, 386.406, 0, 0,
      506.873, 638.483, 549.594, 174.32, 235.276, 6617.79, 9.127, 60099.811,
      8.713, 449.747, 85.074, 93.185, 0, 293.432, 0, 12.279, 0, 16.094, 0,
    ],
    satisfied: [
      0, 0, 6, 6, 0, 2, 0, 0, 0, 0, 0, 0, 1, 4, 1, 1, 0, 0, 1, 0, 765, 0, 0,
      2002, 0, 0, 0, 0, 1, 0, 0, 7, 0, 0, 64, 1, 0, 0, 2, 0, 0, 4, 3, 4, 0, 4,
      0, 1, 0, 1, 0, 0, 0, 3, 3474, 1, 3, 0, 4, 0, 1, 8, 0, 1, 3, 9, 20, 3, 0,
      5, 0, 0, 11, 10, 1, 3, 2, 2, 1, 0, 1, 5, 1, 1, 0, 1, 0, 1, 0, 196, 0,
    ],
    tolerating: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 1, 0, 1, 2, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 6, 11, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 1, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 4, 0, 1, 0, 0, 4, 4,
      3, 1, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    frustrated: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0,
      0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0,
      0, 0, 1, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
  },
  success: {
    count: [
      305994, 253366, 303443, 542113, 476363, 391852, 495650, 479280, 270557,
      314355, 409933, 353854, 534436, 533790, 463052, 303366, 307243, 419207,
      580466, 544581, 524886, 490980, 244190, 289423, 508960, 561041, 580217,
      531211, 446145, 157855, 112826, 407696, 535557, 540449, 495569, 466141,
      216490, 312325, 645599, 618531, 587671, 508108, 444937, 233762, 270478,
      536651, 522373, 536080, 489338, 472961, 315428, 320240, 532953, 517824,
      524860, 369069, 406200, 274103, 255967, 513181, 483134, 543830, 503092,
      465834, 238381, 249891, 515326, 508109, 523367, 459155, 447404, 255380,
      304657, 474561, 549279, 560889, 432023, 250061, 90422, 100106, 285296,
      334938, 340504, 327452, 278093, 94161, 102787, 212615, 328385, 407093,
      316994,
    ],
    mean: [
      52.469, 57.915, 58.606, 49.876, 48.956, 49.98, 60.686, 66.495, 73.42,
      72.193, 57.901, 53.801, 62.116, 61.511, 61.603, 76.138, 75.976, 69.791,
      63.512, 64.49, 67.065, 68.38, 74.158, 64.56, 61.877, 61.46, 62.166,
      66.207, 66.001, 72.768, 70.816, 60.723, 65.514, 64.799, 65.421, 65.521,
      66.616, 60.313, 56.956, 61.165, 57.581, 58.283, 61.873, 69.735, 69.624,
      64.27, 61.237, 61.758, 63.196, 66.074, 73.184, 73.507, 63.91, 60.172,
      61.355, 61.462, 64.726, 71.081, 68.543, 61.387, 60.627, 61.271, 60.445,
      61.235, 67.315, 66.181, 61.3, 60.131, 62.489, 60.068, 63.682, 69.26,
      70.189, 60.94, 60.156, 60.853, 56.748, 51.67, 59.769, 59.242, 51.595,
      50.737, 51.654, 51.718, 53.264, 64.705, 60.413, 50.704, 47.649, 52.529,
      62.247,
    ],
    satisfied: [
      305755, 253162, 303261, 541692, 475925, 391463, 495200, 478749, 270332,
      314139, 409413, 353331, 533953, 533415, 462606, 302986, 307051, 418904,
      579870, 544035, 524384, 490449, 243803, 289049, 508493, 560360, 579785,
      530711, 445558, 157609, 112610, 407164, 535133, 539952, 495077, 465642,
      216260, 312126, 645048, 617991, 587156, 507520, 444328, 233506, 270278,
      536190, 521686, 535588, 488788, 472370, 315174, 319976, 532445, 517118,
      524310, 368747, 405728, 273895, 255754, 512681, 482734, 543450, 502666,
      465307, 238178, 249715, 514802, 507681, 522993, 458721, 446965, 255071,
      304375, 474165, 548890, 560485, 431586, 249613, 90207, 99914, 284852,
      334446, 340102, 327012, 277541, 93906, 102583, 212245, 327977, 406586,
      316710,
    ],
    tolerating: [
      167, 118, 111, 336, 327, 295, 329, 396, 134, 145, 410, 366, 332, 280, 338,
      295, 122, 219, 488, 419, 382, 328, 298, 318, 345, 545, 287, 411, 424, 183,
      168, 441, 321, 389, 383, 385, 141, 142, 437, 403, 397, 469, 429, 156, 131,
      339, 579, 373, 429, 490, 181, 184, 366, 571, 447, 246, 376, 164, 153, 402,
      298, 290, 346, 432, 154, 139, 422, 349, 301, 322, 319, 229, 204, 295, 315,
      327, 310, 343, 141, 135, 337, 368, 295, 350, 420, 180, 162, 299, 316, 346,
      218,
    ],
    frustrated: [
      72, 86, 71, 85, 111, 94, 121, 135, 91, 71, 110, 157, 151, 95, 108, 85, 70,
      84, 108, 127, 120, 203, 89, 56, 122, 136, 145, 89, 163, 63, 48, 91, 103,
      108, 109, 114, 89, 57, 114, 137, 118, 119, 180, 100, 69, 122, 108, 119,
      121, 101, 73, 80, 142, 135, 103, 76, 96, 44, 60, 98, 102, 90, 80, 95, 49,
      37, 102, 79, 73, 112, 120, 80, 78, 101, 74, 77, 127, 105, 74, 57, 107,
      124, 107, 90, 132, 75, 42, 71, 92, 161, 66,
    ],
  },
  time: lastNinetyDays(),
  total: {
    count: [
      312819, 255000, 304863, 551680, 486239, 408447, 506689, 488260, 271900,
      315206, 418432, 363844, 544370, 542287, 471476, 304139, 308769, 423561,
      590576, 554824, 535990, 500165, 245929, 310457, 518932, 571431, 590988,
      542077, 453800, 159349, 114751, 417302, 545904, 552714, 505895, 476681,
      217645, 313024, 656222, 628895, 597944, 519957, 454817, 234883, 271444,
      547390, 532553, 546908, 499274, 483758, 316157, 321164, 544026, 530074,
      540078, 374428, 411904, 275724, 258213, 524183, 493780, 556090, 514034,
      476804, 240475, 250997, 526819, 520252, 536037, 468596, 458580, 257217,
      306146, 487577, 561031, 572487, 446867, 260729, 91394, 100816, 294425,
      346849, 351432, 337503, 288148, 95581, 104005, 221047, 338442, 420575,
      321373,
    ],
    mean: [
      52.238, 57.755, 58.479, 49.714, 48.78, 49.181, 60.445, 66.178, 73.297,
      72.07, 57.744, 53.651, 61.853, 61.347, 61.408, 76.061, 75.715, 69.543,
      63.303, 64.558, 66.629, 68.237, 73.852, 84.772, 61.699, 61.262, 61.856,
      65.885, 65.695, 72.435, 70.38, 60.629, 65.267, 64.403, 64.96, 65.152,
      66.459, 60.248, 56.863, 60.989, 57.316, 57.988, 61.536, 69.56, 69.477,
      65.146, 61.887, 61.688, 62.919, 65.635, 73.086, 73.412, 63.566, 66.309,
      60.774, 61.119, 64.467, 70.818, 68.312, 61.063, 60.212, 60.993, 60.07,
      60.89, 66.996, 66.006, 60.882, 59.742, 62.05, 59.68, 63.231, 69.072,
      70.06, 60.467, 59.932, 60.724, 55.992, 51.48, 59.693, 60.302, 51.42,
      51.428, 52.107, 51.704, 52.929, 64.455, 60.217, 50.572, 47.716, 68.889,
      62.355,
    ],
    stddev: [
      0.114, 0.133, 0.099, 0.08, 0.109, 0.108, 0.1, 0.114, 0.137, 0.121, 0.121,
      0.152, 0.1, 0.093, 0.1, 0.136, 0.117, 0.101, 0.092, 0.214, 0.112, 0.124,
      0.174, 0.409, 0.115, 0.141, 0.135, 0.091, 0.115, 0.199, 0.261, 0.144,
      0.094, 0.091, 0.099, 0.105, 0.155, 0.101, 0.078, 0.095, 0.088, 0.095,
      0.117, 0.154, 0.119, 0.376, 0.332, 0.185, 0.109, 0.103, 0.111, 0.117,
      0.107, 0.239, 0.097, 0.108, 0.132, 0.113, 0.13, 0.09, 0.112, 0.126, 0.088,
      0.096, 0.131, 0.121, 0.096, 0.095, 0.084, 0.105, 0.099, 0.152, 0.119,
      0.103, 0.097, 0.165, 0.11, 0.188, 0.323, 0.89, 0.142, 0.165, 0.16, 0.148,
      0.174, 0.322, 0.254, 0.178, 0.137, 0.366, 0.16,
    ],
    p50: [
      49.76, 56.71, 57.05, 47.035, 44.254, 42.544, 51.723, 54.874, 62.893,
      62.197, 46.01, 40.192, 51.879, 50.649, 51.238, 63.739, 65.435, 57.876,
      52.515, 55.13, 56.565, 55.684, 62.473, 57.207, 51.075, 50.08, 51.969,
      54.37, 52.475, 60.052, 54.361, 45.319, 52.407, 52.509, 50.737, 53.874,
      56.964, 51.911, 46.1, 48.589, 48.801, 48.483, 51.509, 60.444, 61.131,
      53.892, 50.152, 53.834, 52.668, 55.286, 63.384, 62.751, 53.059, 50.248,
      51.106, 52.343, 54.672, 60.896, 59.573, 51.291, 49.59, 51.862, 50.995,
      50.989, 58.393, 57.987, 51.117, 47.923, 52.928, 49.041, 53.103, 58.43,
      59.545, 50.265, 49.991, 50.835, 45.628, 37.065, 43.508, 46.182, 34.539,
      34.363, 41.508, 34.69, 38.084, 50.97, 48.035, 33.985, 32.132, 38.824,
      50.771,
    ],
    p90: [
      87.337, 86.832, 87.374, 82.813, 81.006, 84.91, 110.835, 121.125, 123.071,
      122.314, 111.229, 104.537, 114.572, 111.337, 111.488, 126.728, 126.663,
      123.304, 117.372, 118.291, 122.779, 124.533, 124.794, 130.603, 114.907,
      111.555, 113.108, 122.084, 121.533, 127.231, 136.978, 119.283, 122.358,
      120.857, 120.042, 118.507, 112.69, 106.428, 105.82, 113.12, 103.767,
      103.486, 106.057, 117.079, 117.672, 115.959, 110.676, 105.633, 112.709,
      116.023, 119.895, 120.841, 116.036, 111.087, 109.591, 108.56, 114.912,
      120.508, 117.97, 114.654, 110.934, 111.486, 111.769, 109.32, 114.155,
      113.404, 111.912, 111.321, 113.648, 110.729, 114.926, 118.211, 118.092,
      111.359, 111.662, 111.437, 106.402, 99.815, 112.397, 110.306, 100.305,
      100.266, 98.282, 103.793, 103.804, 118.879, 113.722, 98.135, 95.678,
      103.778, 115.179,
    ],
    p95: [
      104.271, 101.903, 101.763, 102.614, 97.124, 106.667, 136.472, 152.831,
      160.262, 151.305, 140.177, 130.947, 143.492, 143.503, 141.499, 162.933,
      159.966, 162.908, 144.964, 148.42, 155.016, 160.301, 161.293, 167.261,
      144.123, 143.408, 140.165, 155.305, 155.38, 173.54, 186.736, 160.521,
      155.297, 153.205, 154.86, 150.952, 145.95, 133.767, 134.086, 146.623,
      130.272, 131.084, 137.376, 150.925, 150.257, 148.606, 142.657, 136.612,
      146.823, 144.913, 153.641, 155.65, 146.879, 140.816, 141.253, 142.358,
      151.528, 154.803, 150.418, 141.367, 142.448, 141.777, 142.736, 140.685,
      148.053, 143.927, 139.273, 151.459, 145.258, 141.791, 148.732, 159.167,
      152.363, 142.671, 151.139, 143.476, 136.821, 128.902, 138.225, 138.875,
      133.478, 128.185, 124.966, 129.241, 131.503, 154.075, 143.752, 127.013,
      122.848, 136.246, 147.883,
    ],
    p99: [
      156.185, 144.14, 141.883, 156.452, 156.56, 181.58, 212.11, 230.666,
      233.928, 216.161, 220.3, 222.041, 220.599, 214.978, 211.023, 227.918,
      222.752, 218.75, 219.073, 222.135, 225.086, 235.373, 238.884, 853.046,
      212.623, 210.559, 219.388, 230.831, 234.825, 247.052, 276.07, 243.223,
      236.164, 227.837, 230.52, 219.635, 206.739, 200.066, 199.505, 226.224,
      197.112, 201.626, 216.121, 216.512, 207.273, 219.987, 212.628, 212.225,
      223.563, 211.265, 214.957, 222.803, 226.429, 224.178, 213.853, 213.95,
      218.873, 216.23, 212.651, 212.595, 213.844, 217.937, 212.212, 222.982,
      210.202, 201.475, 213.481, 222.891, 216.714, 211.493, 222.835, 220.175,
      219.872, 209.724, 221.957, 213.29, 203.738, 209.589, 223.961, 217.762,
      224.219, 212.943, 206.863, 213.564, 214.52, 233.556, 218.767, 211.768,
      204.485, 292.54, 223.119,
    ],
    satisfied: [
      312558, 254793, 304678, 551243, 485805, 408032, 506224, 487736, 271667,
      314981, 417895, 363223, 543881, 541878, 471021, 303756, 308573, 423252,
      589947, 554260, 535504, 499603, 245540, 307438, 518433, 570733, 590508,
      541561, 453205, 159103, 114515, 416702, 545416, 552204, 505393, 476159,
      217414, 312822, 655641, 628286, 597365, 519358, 454166, 234615, 271227,
      546904, 531821, 546363, 498711, 483154, 315901, 320895, 543504, 528468,
      539486, 374099, 411418, 275514, 257996, 523664, 493370, 555686, 513536,
      476335, 240270, 250825, 526327, 519806, 535649, 468154, 458120, 256903,
      305856, 487143, 560590, 572101, 446379, 260250, 91161, 100618, 293968,
      346242, 350956, 337033, 287637, 95323, 103770, 220671, 338010, 417117,
      321046,
    ],
    tolerating: [
      187, 120, 114, 346, 322, 317, 340, 385, 143, 159, 418, 460, 355, 311, 342,
      287, 125, 218, 515, 431, 365, 355, 286, 796, 363, 557, 345, 409, 430, 183,
      180, 501, 381, 391, 390, 408, 142, 147, 460, 475, 462, 466, 461, 183, 152,
      355, 617, 416, 426, 491, 187, 174, 376, 479, 479, 261, 380, 166, 156, 418,
      305, 306, 420, 373, 156, 132, 386, 369, 310, 330, 340, 229, 209, 329, 357,
      297, 353, 368, 153, 139, 349, 358, 296, 358, 372, 177, 193, 304, 312,
      1248, 228,
    ],
    frustrated: [
      74, 87, 71, 91, 112, 98, 125, 139, 90, 66, 119, 161, 134, 98, 113, 96, 71,
      91, 114, 133, 121, 207, 103, 2223, 136, 141, 135, 107, 165, 63, 56, 99,
      107, 119, 112, 114, 89, 55, 121, 134, 117, 133, 190, 85, 65, 131, 115,
      129, 137, 113, 69, 95, 146, 1127, 113, 68, 106, 44, 61, 101, 105, 98, 78,
      96, 49, 40, 106, 77, 78, 112, 120, 85, 81, 105, 84, 89, 135, 111, 80, 59,
      108, 249, 180, 112, 139, 81, 42, 72, 120, 2210, 99,
    ],
  },
} as any;
